import TextFilter from '@/vue3/components/filter/TextFilter.vue';
import BooleanFilter from '@/vue3/components/filter/BooleanFilter.vue';
import DropdownFilter from '@/vue3/components/filter/DropdownFilter.vue';
import MultiCheckboxFilter from '@/vue3/components/filter/MultiCheckboxFilter.vue';

export default [
    {
        id: 'title',
        name: 'Title',
        filterType: TextFilter,
        options: {
            isOperator: true,
        },
    },
    {
        id: 'accountId',
        name: 'Created by',
        filterType: DropdownFilter,
        options: {
            optionLabel: 'email',
            optionValue: 'id',
            dataKey: 'accounts',
            isOperator: false,
        },
    },
    {
        id: 'assigneeAccountId',
        name: 'Assigned To',
        filterType: DropdownFilter,
        options: {
            optionLabel: 'email',
            optionValue: 'id',
            dataKey: 'accounts',
            isOperator: false,
        },
    },
    {
        id: 'projectId',
        name: 'Project',
        filterType: MultiCheckboxFilter,
        options: {
            optionValue: 'id',
            dataKey: 'projects',
            optionLabel: 'name',
            isOperator: false,
        },
    },
    // {
    //     id: 'holes',
    //     name: 'Holes',
    //     filterType: MultiCheckboxFilter,
    //     options: {
    //         optionValue: 'hole',
    //         optionLabel: 'hole',
    //         dataKey: 'holes',
    //     },
    // },
    {
        id: 'isTask',
        name: 'Is Task',
        filterType: BooleanFilter,
        options: {
            isOperator: false,
        },
    },
    {
        id: 'statusId',
        name: 'Status',
        filterType: DropdownFilter,
        options: {
            optionLabel: 'name',
            optionValue: 'id',
            dataKey: 'status',
            isOperator: false,
        },
    },
    {
        id: 'geoRecordCategoryId',
        name: 'Category',
        filterType: DropdownFilter,
        options: {
            optionLabel: 'name',
            optionValue: 'id',
            dataKey: 'categories',
            isOperator: false,
        },
    },
    {
        id: 'geoRecordTagId',
        name: 'Tags',
        filterType: DropdownFilter,
        options: {
            optionLabel: 'name',
            optionValue: 'id',
            dataKey: 'tags',
            isOperator: false,
        },
    },
];
